import '../styles.css';

function Subheader({ text }) {
	return (
		<div className="subheader">
			<h2 className="subheader_text">{text}</h2>
		</div>
	);
}

export default Subheader;
